import { jsx as _jsx } from "react/jsx-runtime";
import { DataGridPro as MUIDataGridPro, } from "@mui/x-data-grid-pro";
import { styled } from "@mui/material";
import { convertPxToRem } from "../../util-functions";
import { DataGridProLoadingOverlay } from "./DataGridProComponentOverrides/DataGridProLoadingOverlay";
import { DataGridProToolBar } from "./DataGridProComponentOverrides/DataGridProToolBar";
import { Icon } from "../Icon";
import { DataGridProPagination } from "./DataGridProComponentOverrides/DataGridProPagination";
export const StyledDataGridPro = styled(MUIDataGridPro)(({ theme, loading = false, rows, columns }) => ({
    color: theme.palette.secondaryText.main,
    // weird MUI behavior never hides the select all checkbox when the grid  is loading or empty
    "& .MuiDataGrid-columnHeaderCheckbox": {
        display: loading || !rows.length || !columns.length ? "none" : "",
    },
    "& .MuiDataGrid-columnHeaders": {
        backgroundColor: theme.palette.primaryWhite,
    },
    "& .MuiDataGrid-columnHeader": {
        ":focus": {
            outline: "none",
        },
        ":focus-within": {
            outline: "none",
        },
    },
    "& .MuiDataGrid-cell": {
        ":focus": {
            outline: "none",
        },
        ":focus-within": {
            outline: "none",
        },
    },
    "& .MuiDataGrid-row": {
        backgroundColor: theme.palette.primaryWhite,
        "&.Mui-selected": {
            backgroundColor: theme.palette.treezGreen[3],
        },
        "&:hover": {
            backgroundColor: theme.palette.treezGrey[2],
        },
    },
    // pagination component
    "& .MuiPaginationItem-root": Object.assign(Object.assign({ color: theme.palette.primaryBlack.main }, theme.typography.mediumText), { "&.Mui-selected": Object.assign({ backgroundColor: theme.palette.treezGreen[4], color: theme.palette.text.primary }, theme.typography.mediumTextStrong), "&.Mui-disabled": {
            color: theme.palette.disabledText.main,
        }, "&:hover": Object.assign({ color: theme.palette.secondaryText.main, textDecoration: "underline" }, theme.typography.mediumText) }),
    "& .MuiPagination-ul": {
        marginTop: convertPxToRem(24),
        "li:first-of-type": {
            marginRight: convertPxToRem(20),
        },
        "li:last-of-type": {
            marginLeft: convertPxToRem(20),
        },
    },
    // MUI automatically displays row count on ssr, but our designs don't need that
    "& .MuiTablePagination-displayedRows": {
        display: "none",
    },
    // search bar styles
    "& .MuiFormControl-root": {
        backgroundColor: theme.palette.treezGrey[1],
        padding: convertPxToRem(10),
        borderRadius: convertPxToRem(15),
        span: {
            marginRight: convertPxToRem(8),
        },
        marginBottom: convertPxToRem(40),
        ".MuiInput-underline:before": {
            borderBottom: "none",
        },
        ".MuiInput-root": {
            "&:after": {
                borderBottom: "none",
            },
            "&:hover": {
                borderBottom: "none",
            },
        },
    },
}));
// object with icon overrides to be spread out in the DataGridPro's components prop
export const DataGridProIconOverrides = {
    columnSortedAscendingIcon: () => _jsx(Icon, { iconName: "ArrowDropup" }),
    columnSortedDescendingIcon: () => _jsx(Icon, { iconName: "ArrowDropdown" }),
    detailPanelCollapseIcon: () => _jsx(Icon, { iconName: "ChevronDown" }),
    detailPanelExpandIcon: () => _jsx(Icon, { iconName: "ChevronRight" }),
    quickFilterIcon: () => _jsx(Icon, { iconName: "Search" }),
};
export const DataGridPro = (props) => (_jsx(StyledDataGridPro, Object.assign({}, props, { disableColumnMenu: true, disableRowSelectionOnClick: true, pagination: !(props.rowCount <= 20), hideFooterRowCount: props.rowCount <= 20, initialState: Object.assign(Object.assign({}, props.initialState), { pagination: {
            paginationModel: {
                pageSize: 20,
            },
        } }), pageSizeOptions: [20], slots: Object.assign(Object.assign(Object.assign({}, props.slots), DataGridProIconOverrides), { loadingOverlay: DataGridProLoadingOverlay, toolbar: DataGridProToolBar, pagination: DataGridProPagination }) })));
